import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@omnichannel/tokens/css';
import '@omnichannel/themes/css';
import '@omnichannel/ui/styles.css';
import './styles.css';
document.documentElement.dataset.omniTheme = 'graphite-forest-dark';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
